// Selected lunar features (IAU Gazetteer of Planetary Nomenclature, approximate centres),
// chosen as easy binocular targets. Latitude north positive, longitude east positive.
export const MOON_FEATURES: { name: string; lat: number; lon: number; note?: string }[] = [
  { name: 'Sea of Tranquillity', lat: 8.5, lon: 31.4, note: 'Apollo 11 landed here in 1969' },
  { name: 'Sea of Serenity', lat: 28.0, lon: 17.5 },
  { name: 'Sea of Crises', lat: 17.0, lon: 59.1 },
  { name: 'Sea of Rains', lat: 32.8, lon: -15.6 },
  { name: 'Ocean of Storms', lat: 18.4, lon: -57.4 },
  { name: 'Sea of Clouds', lat: -21.3, lon: -16.6 },
  { name: 'Sea of Fertility', lat: -7.8, lon: 51.3 },
  { name: 'Sea of Nectar', lat: -15.2, lon: 35.5 },
  { name: 'Sea of Cold', lat: 56.0, lon: 1.4 },
  { name: 'Sea of Moisture', lat: -24.4, lon: -38.6 },
  { name: 'Tycho', lat: -43.3, lon: -11.4, note: 'young crater with bright rays' },
  { name: 'Copernicus', lat: 9.6, lon: -20.1 },
  { name: 'Kepler', lat: 8.1, lon: -38.0 },
  { name: 'Plato', lat: 51.6, lon: -9.4 },
  { name: 'Clavius', lat: -58.8, lon: -14.1 },
  { name: 'Aristarchus', lat: 23.7, lon: -47.4, note: 'the brightest spot on the Moon' },
  { name: 'Apennine Mountains', lat: 18.9, lon: -3.7 },
  { name: 'Grimaldi', lat: -5.2, lon: -68.6 },
];
